import { useTranslations } from 'next-intl';

import { Button } from '@/components/atoms/Button';

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
  disabled?: boolean;
  onClick?: () => void;
}

export function PlayerNextButton({
  size = 'md',
  disabled = false,
  onClick = () => {},
}: Props) {
  const t = useTranslations();
  const resolveIconSize = () => {
    switch (size) {
      case 'xs':
        return 16;
      case 'sm':
        return 20;
      case 'md':
        return 24;
      case 'lg':
        return 28;
      case 'xl':
        return 32;
      case '2xl':
        return 36;
      case '3xl':
        return 40;
      default:
        return 24;
    }
  };

  return (
    <div>
      <Button
        variant="ghost"
        disabled={disabled}
        onClick={onClick}
        aria-label={t('PLAYER_NEXT_TRACK')}
        className={
          'hover:fill-(--player-text-color-primary-inverted) fill-(--player-text-color-primary)'
        }
      >
        <svg
          aria-hidden="true"
          style={{ width: resolveIconSize(), height: 'auto' }}
          viewBox="0 0 20 21"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.75 4.5C15.3358 4.5 15 4.83579 15 5.25V15.75C15 16.1642 15.3358 16.5 15.75 16.5H16.25C16.6642 16.5 17 16.1642 17 15.75V5.25C17 4.83579 16.6642 4.5 16.25 4.5H15.75Z"
            style={{
              fill: 'inherit',
            }}
          />
          <path
            d="M6.28824 5.31859C5.28891 4.70135 4 5.4202 4 6.59478V14.4053C4 15.5798 5.2889 16.2987 6.28824 15.6815L12.611 11.7762C13.56 11.1901 13.56 9.80998 12.611 9.22382L6.28824 5.31859Z"
            style={{ fill: 'inherit' }}
          />
        </svg>
      </Button>
    </div>
  );
}
